<script>
import AuthLayout from "@/Layouts/AuthLayout.vue";

export default {
    layout: AuthLayout,
};
</script>

<script setup>
import { Head, useForm } from "@inertiajs/vue3";
import BrandButton from "@/Components/Brand/BrandButton.vue";
import BrandInput from "@/Components/Brand/BrandInput.vue";
import BrandPasswordInput from "@/Components/Brand/BrandPasswordInput.vue";

const props = defineProps({
    email: String,
    token: String,
});

const form = useForm({
    token: props.token,
    email: props.email,
    password: "",
    password_confirmation: "",
});

const submit = () => {
    form.post(route("password.update"), {
        onFinish: () => form.reset("password", "password_confirmation"),
    });
};
</script>

<template>
    <Head title="Reset Password" />

    <div class="flex w-full flex-col items-center">
        <div class="flex w-full items-center gap-6 pl-[18px] md:w-auto md:pl-0">
            <img
                :src="asset('images/brand/logo-mark.png')"
                alt="Gift Hero"
                class="hidden size-[75px] shrink-0 object-contain md:block"
            />
            <h1
                class="font-brand-display text-[30px] font-black italic uppercase leading-none tracking-[-0.02em] text-white md:text-[32px]"
            >
                Choose a new<br />password
            </h1>
        </div>

        <form
            class="mt-[38px] w-full max-w-[408px] rounded-brand bg-white p-[18px] shadow-[0px_30px_55px_0px_rgba(0,0,0,0.25)] sm:p-9 md:mt-7"
            @submit.prevent="submit"
        >
            <div class="space-y-[22px]">
                <div>
                    <label
                        for="email"
                        class="mb-0.5 block font-brand text-[15px] font-bold leading-[19px] text-[#3c3938]"
                        >E-Mail Address</label
                    >
                    <BrandInput
                        id="email"
                        v-model="form.email"
                        type="email"
                        required
                        autofocus
                        autocomplete="email"
                    />
                    <p
                        v-if="form.errors.email"
                        class="mt-1.5 text-[13px] text-brand-red"
                    >
                        {{ form.errors.email }}
                    </p>
                </div>

                <div>
                    <label
                        for="password"
                        class="mb-0.5 block font-brand text-[15px] font-bold leading-[19px] text-[#3c3938]"
                        >New Password</label
                    >
                    <BrandPasswordInput
                        id="password"
                        v-model="form.password"
                        required
                        autocomplete="new-password"
                    />
                    <p
                        v-if="form.errors.password"
                        class="mt-1.5 text-[13px] text-brand-red"
                    >
                        {{ form.errors.password }}
                    </p>
                </div>

                <div>
                    <label
                        for="password_confirmation"
                        class="mb-0.5 block font-brand text-[15px] font-bold leading-[19px] text-[#3c3938]"
                        >Confirm New Password</label
                    >
                    <BrandPasswordInput
                        id="password_confirmation"
                        v-model="form.password_confirmation"
                        required
                        autocomplete="new-password"
                    />
                    <p
                        v-if="form.errors.password_confirmation"
                        class="mt-1.5 text-[13px] text-brand-red"
                    >
                        {{ form.errors.password_confirmation }}
                    </p>
                </div>
            </div>

            <BrandButton
                type="submit"
                class="mt-8 h-11 w-full text-[15px]"
                :class="{ 'pointer-events-none opacity-60': form.processing }"
                :disabled="form.processing"
                :loading="form.processing"
            >
                Reset Password
            </BrandButton>
        </form>
    </div>
</template>
